const pluralizeFilter = function () {
  return function (text, count, irregular) {
    return count === 1 ? text : !irregular ? `${text}s` : irregular
  }
}
export default pluralizeFilter
